import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gaoDaList, staApplyNum } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      count: 0,
      content1: '',
      content2: '',
      content3: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.reloadData();
    }, 60 * 1000);
    this.reloadData();
  },
  methods: {
    reloadData: function reloadData() {
      var _this2 = this;

      staApplyNum({}).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.content1 = '高达申请（' + res.gaoda + '）人未处理';
                _this2.content2 = '进货申请（' + res.purchase + '）人未处理';
                _this2.content3 = '提现申请（' + res.withdrawal + '）人未处理';
                _this2.count = res.gaoda + res.purchase + res.withdrawal;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};